import { render, staticRenderFns } from "./role-edit-modal.vue?vue&type=template&id=26c5bbc0&scoped=true&"
import script from "./role-edit-modal.vue?vue&type=script&lang=js&"
export * from "./role-edit-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c5bbc0",
  null
  
)

export default component.exports